import { Popup } from "semantic-ui-react";
import { useUser } from "../../contexts/useUserData";
import { useState } from "react";
import { useChat } from "../../contexts/useChatData";
import { useMediaQuery } from "@react-hook/media-query";
import "semantic-ui-css/semantic.min.css";

interface propsType {
    content: string;
    menuOpen: Function;
}

export const PopupFavQuestions = (propsData: propsType) => {
    const { isLoading } = useChat();
    const { isFavQuestionClicked, user, scope, token } = useUser();
    const isResponsive = useMediaQuery("only screen and (max-width: 768px)");
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = async () => {
        if (!isLoading && user && scope) {
            isFavQuestionClicked!(true, propsData.content);
            if (isResponsive) {
                propsData.menuOpen();
            }
        } else {
            console.warn("No se pudo registrar la pregunta en el historial. Valores: ", { isLoading, user, scope });
        }
        setIsOpen(false);
    };

    return (
        <Popup
            trigger={
                <p
                    id="popup-favorite"
                    onClick={() => {
                        console.log("Pregunta seleccionada:", propsData.content);
                        if (!isLoading) {
                            handleClick();
                        }
                    }}
                >
                    {propsData.content}
                </p>
            }
            position={isResponsive ? "top center" : "right center"}
            on={isResponsive ? "click" : "hover"}
            open={isResponsive ? isOpen : undefined}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            disabled={isLoading}
        >
            <div onClick={handleClick}>
                {propsData.content}
            </div>
        </Popup>
    );
};
